import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPendingPublishing } from "../../../api/adminClientPublishingApi";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminStatePanel from "../../../components/midpoint/admin/layout/AdminStatePanel";
import StatusBadge from "../../../components/midpoint/intelligence/StatusBadge";
import { formatDateTime } from "../../../components/midpoint/admin/users/adminUserFormatters";

function AdminClientPublishingPendingPageContent() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [contentType, setContentType] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setErrorMessage("");
    try {
      const body = await listPendingPublishing({
        search: search || undefined,
        contentType: contentType || undefined,
      });
      setData(body);
    } catch (error) {
      setErrorMessage(error.message || "Unable to load pending submissions.");
    } finally {
      setLoading(false);
    }
  }, [search, contentType]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <AdminPageLayout>
      <AdminPageHeader
        title="Client Publishing Review"
        description="Review and publish client-submitted community and course content"
      />

      <div className="admin-toolbar panel-card">
        <label className="admin-users-field">
          <span>Search</span>
          <input value={search} onChange={(e) => setSearch(e.target.value)} />
        </label>
        <label className="admin-users-field">
          <span>Content type</span>
          <select value={contentType} onChange={(e) => setContentType(e.target.value)}>
            <option value="">All</option>
            <option value="community">Community</option>
            <option value="course">Course</option>
          </select>
        </label>
      </div>

      {loading ? <AdminStatePanel message="Loading pending submissions…" /> : null}
      {errorMessage ? <AdminStatePanel variant="error" message={errorMessage} /> : null}

      {!loading && data?.submissions?.length === 0 ? (
        <AdminStatePanel message="No submissions pending review." />
      ) : null}

      {data?.submissions?.length > 0 ? (
        <div className="panel-card">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Organization</th>
                <th>Client View</th>
                <th>Type</th>
                <th>Title</th>
                <th>Submitted</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {data.submissions.map((row) => (
                <tr key={row.contentVersionId}>
                  <td>{row.organizationName || "—"}</td>
                  <td>{row.clientViewName || row.clientViewId}</td>
                  <td>{row.contentType}</td>
                  <td>{row.title || "—"}</td>
                  <td>
                    {row.submittedAt ? formatDateTime(row.submittedAt) : "—"}
                    {row.submittedByEmail ? (
                      <span className="muted"> · {row.submittedByEmail}</span>
                    ) : null}
                  </td>
                  <td>
                    <StatusBadge tone="warning" label={row.publishStatusLabel} />
                  </td>
                  <td>
                    <Link
                      to={`/admin/client-publishing/${row.contentVersionId}`}
                      className="cv-button-link"
                    >
                      Review
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </AdminPageLayout>
  );
}

export default function AdminClientPublishingPendingPage() {
  return <AdminClientPublishingPendingPageContent />;
}
